import type { ApiAccount } from '@api/user/types';

import type { Account } from './types';

const accountModel = ({
  id,
  name,
  website = '',
  address = '',
  zipCode = '',
  city = '',
  country = '',
  phonePrefix = '',
  phoneNumber = '',
  taxNumber = '',
  is2faMandatory = false,
  isSingleEntity = false,
  isVatglobal = false,
  managedServiceProvider = '',
}: ApiAccount): Account => ({
  id,
  name,
  website,
  address,
  zipCode,
  city,
  country,
  phonePrefix,
  phoneNumber,
  taxNumber,
  is2faMandatory,
  isSingleEntity,
  isMspAccount: isVatglobal,
  managedServiceProvider,
});

export default accountModel;
